import { render, staticRenderFns } from "./TransferSyllablesSchoolPreparingForm.vue?vue&type=template&id=156a6b81&scoped=true&lang=pug&"
import script from "./TransferSyllablesSchoolPreparingForm.vue?vue&type=script&lang=js&"
export * from "./TransferSyllablesSchoolPreparingForm.vue?vue&type=script&lang=js&"
import style0 from "./TransferSyllablesSchoolPreparingForm.vue?vue&type=style&index=0&id=156a6b81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156a6b81",
  null
  
)

export default component.exports